import { memo } from 'react';
import { Focusable } from 'react-aria-components';

import { Label, Text, Tooltip, TooltipTrigger } from '@/components/core';
import { DoubleCheckmarkIcon } from '@/components/icons';
import { DivProps, OmitChildren } from '@/utils';

export type FieldLabelProps = {
  description?: string;
  name: string;
  hideLabel?: boolean;
  isReviewed?: boolean;
} & OmitChildren<DivProps>;

const IFieldLabel = ({ name, description, hideLabel = false, isReviewed, ...rest }: FieldLabelProps) => {
  return (
    <div className="group/field-label flex items-center gap-2" {...rest}>
      <TooltipTrigger isDisabled={!description}>
        <Focusable excludeFromTabOrder>
          <Label hidden={hideLabel} htmlFor={name}>
            {name}
          </Label>
        </Focusable>

        <Tooltip variant="primary" placement="left">
          <Text slot="description">{description}</Text>
        </Tooltip>
      </TooltipTrigger>

      {isReviewed ? (
        <TooltipTrigger>
          <Focusable excludeFromTabOrder>
            <DoubleCheckmarkIcon className="size-3 text-gray-300" />
          </Focusable>

          <Tooltip variant="primary">
            <Text slot="description">Viewed by you</Text>
          </Tooltip>
        </TooltipTrigger>
      ) : null}
    </div>
  );
};

export const FieldLabel = memo(IFieldLabel) as typeof IFieldLabel;
